export default __webpack_public_path__ + "static/media/trr-event-default.6bc4790d.png";